import React from "react";
import {
  useAddPageMutation,
  useDeletePageMutation,
  useGetPagesQuery,
  useUpdatePageMutation,
} from "../../features/pages/pageApi";
import MasterCrudPage from "../masters/MasterCrudPage";
import { withAuditFilters } from "../masters/filterMetadata";

const fields = [
  { name: "page_name", label: "Page Name", placeholder: "Enter page name", required: true, fullWidth: true },
];
const columns = [
  { name: "Page ID", selector: (row) => row?.page_id || "-", sortable: true },
  { name: "Page Name", selector: (row) => row?.page_name || "-", sortable: true, grow: 2 },
];
const filterFields = withAuditFilters([
  { name: "page_id", label: "Page ID" },
  { name: "page_name", label: "Page Name" },
]);

const Page = () => (
  <MasterCrudPage
    entityName="Page"
    pageTitle="Page Master"
    idField="page_id"
    displayField="page_name"
    fields={fields}
    columns={columns}
    searchFields={["page_id", "page_name"]}
    searchPlaceholder="Search pages"
    useListQuery={useGetPagesQuery}
    useCreateMutation={useAddPageMutation}
    useUpdateMutation={useUpdatePageMutation}
    useDeleteMutation={useDeletePageMutation}
    filterFields={filterFields}
    showPlantFilter={false}
    noDataLabel="No pages found"
  />
);

export default Page;
